export const REQUEST_EVENT_ACTIVITY_LOGS = 'REQUEST_EVENT_ACTIVITY_LOGS';
export const RECEIVE_EVENT_ACTIVITY_LOGS = 'RECEIVE_EVENT_ACTIVITY_LOGS';
export const RECEIVE_EVENT_ACTIVITY_LOGS_ERROR = 'RECEIVE_EVENT_ACTIVITY_LOGS_ERROR';
